/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * One problem draft to format into statement HTML.
 * @export
 * @interface FormatProblemRequest
 */
export interface FormatProblemRequest {
    /**
     * 
     * @type {string}
     * @memberof FormatProblemRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof FormatProblemRequest
     */
    marked_text: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof FormatProblemRequest
     */
    images?: { [key: string]: string; };
}

/**
 * Check if a given object implements the FormatProblemRequest interface.
 */
export function instanceOfFormatProblemRequest(value: object): value is FormatProblemRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('marked_text' in value) || value['marked_text'] === undefined) return false;
    return true;
}

export function FormatProblemRequestFromJSON(json: any): FormatProblemRequest {
    return FormatProblemRequestFromJSONTyped(json, false);
}

export function FormatProblemRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormatProblemRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'marked_text': json['marked_text'],
        'images': json['images'] == null ? undefined : json['images'],
    };
}

export function FormatProblemRequestToJSON(json: any): FormatProblemRequest {
    return FormatProblemRequestToJSONTyped(json, false);
}

export function FormatProblemRequestToJSONTyped(value?: FormatProblemRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'marked_text': value['marked_text'],
        'images': value['images'],
    };
}

